<script>
  import options from './ChatMessageCards.options'
  export default options
</script>

<template>
    <ul v-if="cards && cards.length !== 0" c
      class="nyk-chat-message-cards nyk-standard-card-layout__content nyk-standard-card-layout__content--4-cols"
      aria-live="polite">
      <chat-message-card v-for="(card) in cards"
          :href="card.url"
          :title="card.title"
          :description="card.excerpt"
          readmoreLabel="Læs mere"
          :filename="card.filename" />
    </ul>
</template>
